import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-8634c3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "me-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "body"
}
const _hoisted_8 = { class: "row mt-4" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "form-group w-100" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex align-items-center me-3" }
const _hoisted_15 = { class: "d-flex align-items-center me-3" }
const _hoisted_16 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_18 = { class: "form-group w-100" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center me-3" }
const _hoisted_21 = { class: "d-flex align-items-center me-3" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "table table-striped mt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { colspan: "99" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "text-center mt-3" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.productionPhase), 1),
        _createVNode(_component_localized_text, {
          localizedKey: "Transportation",
          text: "Transportation"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Origin Country",
                labelValue: "Origin Country",
                placeholderKey: "Origin Country",
                placeholderValue: "Origin Country",
                list: _ctx.countries,
                modelValue: _ctx.modelTransportType.from,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelTransportType.from) = $event)),
                  _ctx.checkKmsFromConfiguration
                ],
                readonly: _ctx.originCountryReadonly
              }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  type: "label",
                  localizedKey: "Is the next production site the same as the current production site?",
                  text: "Is the next production site the same as the current production site?"
                }),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["sameAsOptionButton pointer me-2", { active: !_ctx.differentNextProductionSite }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.differentNextProductionSite = false))
                    }, null, 2),
                    _createVNode(_component_localized_text, {
                      class: "font-weight-bold",
                      localizedKey: "Yes",
                      text: "Yes"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["sameAsOptionButton pointer me-2", { active: _ctx.differentNextProductionSite }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.differentNextProductionSite = true))
                    }, null, 2),
                    _createVNode(_component_localized_text, {
                      class: "font-weight-bold",
                      localizedKey: "No",
                      text: "No"
                    })
                  ])
                ])
              ])
            ]),
            (_ctx.differentNextProductionSite)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_form_field, {
                    type: "select",
                    labelKey: "Destination Country",
                    labelValue: "Destination Country",
                    placeholderKey: "Destination Country",
                    placeholderValue: "Destination Country",
                    list: _ctx.countries,
                    modelValue: _ctx.modelTransportType.to,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelTransportType.to) = $event)),
                      _ctx.checkKmsFromConfiguration
                    ]
                  }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_localized_text, {
                type: "label",
                localizedKey: "Transport type",
                text: "Transport type"
              }),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsOptionButton pointer me-2", { active: _ctx.isTransportInternational }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isTransportInternational = true))
                  }, null, 2),
                  _createVNode(_component_localized_text, {
                    class: "font-weight-bold",
                    localizedKey: "International",
                    text: "International"
                  })
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsOptionButton pointer me-2", { active: !_ctx.isTransportInternational }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isTransportInternational = false))
                  }, null, 2),
                  _createVNode(_component_localized_text, {
                    class: "font-weight-bold",
                    localizedKey: "Domestic/Land",
                    text: "Domestic/Land"
                  })
                ])
              ])
            ]),
            (_openBlock(), _createBlock(_component_form_field, {
              type: "select-string",
              labelKey: "Transport",
              labelValue: "Transport",
              placeholderKey: "Transport",
              placeholderValue: "Transport",
              list: _ctx.filteredTransportTypesFromIsInternational,
              modelValue: _ctx.modelTransportType.transportType,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelTransportType.transportType) = $event)),
                _ctx.checkKmsFromConfiguration
              ],
              key: _ctx.isTransportInternational,
              class: "w-100 ms-2"
            }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])),
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Distance (KM)",
              labelValue: "Distance (KM)",
              placeholderKey: "Distance (KM)",
              placeholderValue: "Distance (KM)",
              modelValue: _ctx.modelTransportType.distance,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelTransportType.distance) = $event)),
              class: "w-100 mx-2"
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              disabled: !_ctx.canAdd,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addTransportType()))
            }, "+", 8, _hoisted_22)
          ]),
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Transport Type",
                    text: "Transport Type"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Distance km",
                    text: "Distance km"
                  })
                ]),
                _hoisted_24
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.model.transportTypes.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                    _createElementVNode("td", _hoisted_26, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "No Elements Found",
                        text: "No Elements Found"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.transportTypes, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(item.transportType), 1),
                  _createElementVNode("td", null, _toDisplayString(item.distance) + " km", 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.removeTransportType(i))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Remove",
                        text: "Remove"
                      })
                    ], 8, _hoisted_27)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-tertiary",
              disabled: _ctx.isDisabled,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_29)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}